/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Type_EventInputs */

const vi_work_activity_type_event = /** @type {(inputs: Work_Activity_Type_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện`)
};

/**

* @param {Work_Activity_Type_EventInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_type_event = /** @type {((inputs?: Work_Activity_Type_EventInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Type_EventInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_type_event(inputs)
});